import React, { useEffect } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb, Grid, Header, Menu, Segment } from 'semantic-ui-react';
import FavoriteIcon from 'shared/FavoriteIcon';
import RestrictedView from 'shared/RestrictedView';
import subscriptionActions from "actions/subscription";
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS, productRestriction } from 'dyl-components';

const ROUTES = {
    general: 'general/call-recording',
    numbers: 'numbers/dyl-numbers',
    externalNumbers: 'numbers/external-numbers',
    extensions: 'extensions/users',
    devices: 'devices',
    routing: 'routing/ring-group-call-queues',
    audio: 'audio',
    tcr: 'tcr/brand-registration'
}

const PhoneManagement = ({ favorite_type, type }) => {
    const customer_id = useSelector(state => state.auth.customer_id);
    const details = type ? {
        favorite_type: favorite_type || "settings",
        setting_report_type: type
    } : {};
    const location = useLocation();
    
    const { productPermissions } = useSelector(state => ({
        productPermissions: state.subscription.productPermissions,
    })); 
    
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(subscriptionActions.getTcrDetails());
    }, [customer_id, dispatch]);
    
    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <Header as="h2">
                        {details && <FavoriteIcon details={details} />}
                        <Header.Content>Phone Management</Header.Content>
                    </Header>
                    <Breadcrumb style={{marginBottom: 10}}>
                        <Breadcrumb.Section as={Link} to="/settings/general">Settings</Breadcrumb.Section>
                        <Breadcrumb.Divider />
                        <Breadcrumb.Section as={Link} to={`/settings/phone-management`}>Phone Management</Breadcrumb.Section>
                    </Breadcrumb>
                    <p>Manage your numbers, extensions, routing, IVR, prompts, and more.</p>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
                <Grid.Column style={{ paddingTop: '1em', paddingRight: 0, paddingLeft: '0.5em' }}>
                    <Menu borderless pointing secondary color='primary' stackable size='huge'>
                        <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT + ROUTES.general} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='General' as={NavLink} to={ROUTES.general} active={location?.pathname?.includes("/general/")} />
                        </RestrictedView>
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='Numbers' as={NavLink} to={!productRestriction(PRODUCT_PERMISSIONS.OFFICE_VIEW, productPermissions) ? ROUTES.externalNumbers : ROUTES.numbers} active={location?.pathname?.includes("/numbers/")} />
                        </RestrictedView>
                        <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT + ROUTES.extensions} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='Extensions' as={NavLink} to={ROUTES.extensions} active={location?.pathname?.includes("/extensions/")} />
                        </RestrictedView>
                        <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT + ROUTES.devices} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='Devices' as={NavLink} to={ROUTES.devices} />
                        </RestrictedView>
                        <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT + ROUTES.routing} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='Routing' as={NavLink} to={ROUTES.routing} active={location?.pathname?.includes("/routing/")} />
                        </RestrictedView>
                        <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT + ROUTES.audio} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                            <Menu.Item name='Audio' as={NavLink} to={ROUTES.audio} />
                        </RestrictedView>
                        <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT + ROUTES.tcr} userPermission={USER_PERMISSIONS.BRAND_REGISTRATION_VIEW}>
                            <Menu.Item name='TCR' active={location?.pathname?.includes("/tcr/")} as={NavLink} to={ROUTES.tcr} />
                        </RestrictedView>
                    </Menu>
                    <Segment basic>
                        <Outlet />
                    </Segment>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}

export default PhoneManagement;
